export default {
    data() {
        return {
            formRules: {
                required: v => !!v || "*必填",
                checkbox: v => !!v.length || "*至少擇一",
                email: v => /.+@.+\..+/.test(v) || "格式錯誤",
                amount: v => Number.isInteger(v) && v > 0 || "須為大於零的整數"
            }
        }
    }
}
